// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB4tfL3rCFxFa5kVv5R_xSrSIPKD_nAi9Q",
  authDomain: "schulschrift.firebaseapp.com",
  projectId: "schulschrift",
  storageBucket: "schulschrift.firebasestorage.app",
  messagingSenderId: "189332517130",
  appId: "1:189332517130:web:23122bb0d3adc6ba1a4af3",
  measurementId: "G-ZEFC779NTL",
};

// Initialize Firebase (Kern-App + Firestore sind für den Betrieb technisch
// notwendig und dürfen ohne Einwilligung geladen werden).
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// Google Analytics setzt nicht-notwendige Cookies bzw. greift auf das Endgerät
// zu (§ 25 TDDDG). Es darf daher ERST nach ausdrücklicher Einwilligung geladen
// werden. Deshalb kein eager getAnalytics() beim Start, sondern lazy über den
// Cookie-Consent-Banner (siehe components/CookieConsent.jsx).
let analyticsInstance = null;

export async function initAnalytics() {
  if (analyticsInstance) return analyticsInstance;
  if (typeof window === "undefined") return null;
  try {
    const { getAnalytics, isSupported } = await import("firebase/analytics");
    if (!(await isSupported())) return null;
    analyticsInstance = getAnalytics(app);
    return analyticsInstance;
  } catch (err) {
    console.warn("Analytics konnte nicht initialisiert werden:", err);
    return null;
  }
}

export { app, db };
